'use client';

import { useCallback } from 'react';

import {
  getProfessionalProceduresFromSearchApi,
  mergeProcedureGroups,
  ProfessionalProcedureGroup,
} from '@/app/(main)/(pages)/(institucional)/(index)/profissionais/_services/get-professional-procedures-from-search-api.service';
import {
  EntityProceduresChannelState,
  useEntityProcedures,
  UseEntityProceduresReturn,
} from '@/app/(main)/(pages)/_components/entities/entity-procedure/_hooks/use-entity-procedures.hook';
import { SearchApiServiceChannel } from '@/app/(main)/(pages)/_types/search-api-response.type';

export type ProfessionalProceduresChannelState = EntityProceduresChannelState<ProfessionalProcedureGroup>;
export type UseProfessionalProceduresReturn = UseEntityProceduresReturn<ProfessionalProcedureGroup>;

export interface UseProfessionalProceduresOptions {
  enabled?: boolean;
}

export function useProfessionalProcedures(
  professionalId: string,
  { enabled = true }: UseProfessionalProceduresOptions = {},
): UseProfessionalProceduresReturn {
  const fetchPage = useCallback(
    ({ serviceChannel, page }: { serviceChannel: SearchApiServiceChannel; page: number }) =>
      getProfessionalProceduresFromSearchApi({ professionalId, serviceChannel, page }),
    [professionalId],
  );

  return useEntityProcedures({ fetchPage, mergeGroups: mergeProcedureGroups, enabled });
}
